import {styled} from "@mui/material/styles";

export const CaptionDiv = styled('div')(({theme}) => ({
    position: 'absolute',
    bottom: 0,
    zIndex: 65535,
    fontFamily: 'sans-serif',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1,
    color: '#ffffff',
    padding: '5px 5px',
    width: '100%',
    overflowWrap: 'break-word',
    background: 'rgb(0 0 0 / 25%)',
}));
